/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

import { STORE_ACTION_RANKING_FRAGMENT } from '../fragments/StoreActionRankingFragment'

export const GET_STORE_ACTION_COMPLETION = gql`
  query GetStoreActionCompletion(
    $filters: ActionsInput!
    $order: SortDirection
    $pagination: OffsetLimitPaginationFilter
  ) {
    storeActionCompletion(
      filters: $filters
      order: $order
      pagination: $pagination
    ) {
      results {
        ...StoreActionRanking
      }
      totalCount
    }
  }
  ${STORE_ACTION_RANKING_FRAGMENT}
`
